import { render, staticRenderFns } from "./StatReportDetail.vue?vue&type=template&id=96a02418&scoped=true"
import script from "./StatReportDetail.vue?vue&type=script&lang=js"
export * from "./StatReportDetail.vue?vue&type=script&lang=js"
import style0 from "./StatReportDetail.vue?vue&type=style&index=0&id=96a02418&prod&scoped=true&lang=css"
import style1 from "./StatReportDetail.vue?vue&type=style&index=1&id=96a02418&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96a02418",
  null
  
)

export default component.exports